"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HomeeAggregateError", {
    enumerable: true,
    get: function() {
        return HomeeAggregateError;
    }
});
const _serializeerror = require("serialize-error");
let HomeeAggregateError = class HomeeAggregateError extends Error {
    toString() {
        let out = this.message;
        if (this.innerErrors) {
            out += this.innerErrors.map((e)=>`\n${JSON.stringify(e, null, 4)}`).join('\n------------------------\n');
        }
        return out;
    }
    constructor(message, errors){
        super(message);
        this.name = 'HomeeError';
        this.logLevel = 'error';
        this.innerErrors = errors.map((e)=>(0, _serializeerror.serializeError)(e, {
                maxDepth: 3
            }));
    }
};

//# sourceMappingURL=homee-aggregate.error.js.map